<template>
  <div>
    <b-card no-body>
      <div class="card-smallHeader card-header-action" v-b-toggle.collapse-donnees-dbco>
        <span><b>Données DBCO</b></span> <i class="fa fa-exclamation text-danger ml-2" v-if="errors.isConforme !== '' || errors.reponseDb !== '' || errors.dateSignature !== '' || errors.dateReceptionCourrier !== '' || errors.dbcoType !== '' || errors.selectedAccuseReception !== '' || errors.selectedMotifsRejet !== ''"></i>
        <div class="card-header-actions">
              <span class="when-opened">
                      <i class="icon-arrow-down"></i>
                    </span>
          <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
        </div>
      </div>
      <b-collapse id="collapse-donnees-dbco" class="m-3" v-model="isNotTraitementQC" :class="isNotTraitementQC && (errors.isConforme !== '' || errors.reponseDb !== '' || errors.dateSignature !== '' || errors.dateReceptionCourrier !== '' || errors.dbcoType !== '' || errors.selectedAccuseReception !== '' || errors.selectedMotifsRejet !== '') ? null : 'collapsed'">
        <b-row>
          <b-col sm="6">
            <b-form-group
              label-for="dateReception"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>{{ myData.typeSupport === 'email' ? 'Date de réception' : 'Date de scan'}} :</b></template>
              <b-form-input
                type="date"
                id="dateReception"
                :disabled="isDisabled('dateReception')"
                v-model="myData.dateReception">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              label-for="typeSupport"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>Support :</b></template>
              <b-form-radio-group id="typeSupport" v-model="myData.typeSupport" name="typeSupport" :disabled="isDisabled('typeSupport')">
                <b-form-radio value="papier">Papier</b-form-radio>
                <b-form-radio value="email">Electronique</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="myData.typeSupport === 'papier'">
          <b-col sm="6">
            <b-form-group
              label-for="dateReceptionCourrier"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>Date réception courrier :</b></template>
              <b-form-input
                type="date"
                id="dateReceptionCourrier"
                :disabled="isDisabled('dateReceptionCourrier')"
                v-model="myData.dateReceptionCourrier"
                :class="{hasError: errors.dateReceptionCourrier !== ''}">
              </b-form-input>
              <span class="field-error">{{ errors.dateReceptionCourrier }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
              label-for="dateSignature"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>Date signature :</b></template>
              <b-form-input
                class="col-sm-8 d-inline-block"
                type="date"
                id="dateSignature"
                :disabled="isDisabled('dateSignature')"
                v-model="myData.dateSignature"
                :class="{hasError: errors.dateSignature !== ''}">
              </b-form-input>
              <b-form-input
                class="col-sm-4 d-inline-block"
                type="time"
                id="timeSignature"
                :disabled="isDisabled('dateSignature')"
                v-model="myData.timeSignature">
              </b-form-input>
              <span class="field-error">{{ errors.dateSignature }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              label-for="dbcoType"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>Document :</b></template>
              <b-form-radio-group id="dbcoType" v-model="myData.dbcoType" name="dbcoType" :disabled="isDisabled('dbcoType')" :class="{hasError: errors.dbcoType !== ''}">
                <b-form-radio value="DB">DB</b-form-radio>
                <b-form-radio value="CO">CO</b-form-radio>
              </b-form-radio-group>
              <span class="field-error">{{ errors.dbcoType }}</span>
          </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="myData.dbcoType === 'DB'">
          <b-col sm="6">
            <b-form-group
              label-for="reponseDb"
              :label-cols="3"

              :horizontal="true">
              <template slot="label"><b>Réponse DB :</b></template>
              <b-form-radio-group id="reponseDb" v-model="myData.reponseDb" name="reponseDb" :disabled="isDisabled('reponseDb')" :class="{hasError: errors.reponseDb !== ''}">
                <b-form-radio value="type">Clause Type</b-form-radio>
                <b-form-radio value="expresse">Clause Expresse</b-form-radio>
              </b-form-radio-group>
              <span class="field-error">{{ errors.reponseDb }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              label-for="garantiePret"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>Garantie de prêt :</b></template>
              <b-form-checkbox
                id="garantiePret"
                v-model="myData.garantiePret"
                name="garantiePret"
                value="true"
                unchecked-value="not_garantiePret"
                :disabled="isDisabled('garantiePret')"
              >
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="myData.dbcoType === 'CO'">
          <b-col sm="6">
            <b-form-group
              label-for="reponseDb"
              :label-cols="3"

              :horizontal="true">
              <template slot="label"><b>Réponse CO :</b></template>
              <b-form-radio-group id="reponseDb" v-model="myData.reponseDb" name="reponseDb" :disabled="isDisabled('reponseDb')" :class="{hasError: errors.reponseDb !== ''}">
                <b-form-radio value="option1">Option 1</b-form-radio>
                <b-form-radio value="option2">Option 2</b-form-radio>
                <b-form-radio value="option3">Option 3</b-form-radio>
              </b-form-radio-group>
              <span class="field-error">{{ errors.reponseDb }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
              label-for="accuseReception"
              :label-cols="3"

              :horizontal="true">
              <template slot="label"><b>Accusé réception :</b></template>
              <b-form-select v-model="myData.selectedAccuseReception"
                             :options="allTypesAROptions"
                             :class="{hasError: errors.selectedAccuseReception !== ''}"
                             :disabled="isDisabled('accuseReception')">
                <template #first>
                  <b-form-select-option :value="null" disabled>-- Sélectionner un type d'AR --</b-form-select-option>
                </template>
              </b-form-select>
              <span class="field-error">{{ errors.selectedAccuseReception }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              label-for="canalSignalement"
              :label-cols="3"

              :horizontal="true">
              <template slot="label"><b>Canal de signalement :</b></template>
              <b-form-select v-model="myData.selectedCanal"
                             :options="allCanals"
                             disabled>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
              label-for="isConforme"
              :label-cols="3"

              :horizontal="true">
              <template slot="label"><b>Analyse :</b></template>
              <b-form-radio-group id="isConforme" v-model="myData.isConforme" name="isConforme" :disabled="isDisabled('isConforme')" :class="{hasError: errors.isConforme !== ''}">
                <b-form-radio value="true">Conforme</b-form-radio>
                <b-form-radio value="false">Non conforme</b-form-radio>
              </b-form-radio-group>
              <span class="field-error">{{ errors.isConforme }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              label-for="motifsRejet"
              :label-cols="3"
              v-if="showMotifsRejet"
              :horizontal="true">
              <template slot="label"><b>Motifs rejet :</b></template>
              <multiselect
                selectLabel='Appuyer sur entrer pour sélectionner'
                selectedLabel='Sélectionné' deselectLabel='Appuyer sur entrer pour désélectionner'
                :close-on-select="false"
                v-model="motifsRejet"
                tag-placeholder="Choisissez un motif"
                placeholder="Choisissez un motif"
                label="name"
                track-by="code"
                :options="allMotifsRejetOption"
                :multiple="true"
                :taggable="true"
                :disabled="isDisabled('motifsRejet')" :class="{hasError: errors.selectedMotifsRejet !== ''}">
              </multiselect>
              <span class="field-error">{{ errors.selectedMotifsRejet }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
              label-for="dbcoUuid"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>uuid Chorum :</b></template>
              <b-form-input
                type="text"
                id="dbcoUuid"
                :disabled="isDisabled('dbcoUuid')"
                v-model="myData.dbcoUuid"
                :class="{hasError: errors.dbcoUuid !== ''}">
              </b-form-input>
              <span class="field-error">{{ errors.dbcoUuid }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              label-for="yousignId"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>Yousign Id :</b></template>
              <b-form-input
                type="text"
                id="yousignId"
                :disabled="isDisabled('yousignId')"
                v-model="myData.yousignId"
                :class="{hasError: errors.yousignId !== ''}">
              </b-form-input>
              <span class="field-error">{{ errors.yousignId }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
              label-for="numArchives2"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>N° d'archives :</b></template>
              <b-form-input id="numArchives2" :disabled="isDisabled('numArchives')"
                            type="text" v-model="myData.numArchives">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              label-for="rar"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>RAR :</b></template>
              <b-form-input id="rar" type="text" v-model="myData.rar" :disabled="isDisabled('rar')">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <div>
          <span v-b-tooltip.hover.righttop="{ customClass: 'pre-formatted' }"
                :title="getTooltip()"
                :id="'tooltip-note-'+dossier.id">
            <img class="clickable" :src="getIconSrc('post-it', dossier)" @click="editCommentaire(dossier)" alt="post-it"/>
          </span>
        </div>
      </b-collapse>
    </b-card>
    <b-modal size="xl" scrollable id="modal-commentaire" ref="modal-commentaire" title="Commentaires sur le dossier">
      <b-row v-for="(commentaire) of commentairesGestion" class="align-items-center" :key="commentaire.id">
        <b-col md="10" style="display: inline-block;">
          <label>Commentaire
            <span class="smaller-2">
              <i>Dernière modification le {{ formatDateHeure(commentaire.updated_at) }} par 
                <span v-if="commentaire.gestionnaire != null">{{ commentaire.gestionnaire.prenom }} {{ commentaire.gestionnaire.nom }}</span>
                <span v-else> Système</span>
              </i>
            </span>
          </label>
          <b-form-textarea
            :id="'commentaire-'+commentaire.id"
            v-model="commentaires[commentaire.id].texte"
            placeholder="Saisir un commentaire..."
            rows="3"
            max-rows="6"
            :class="{hasError: errors.commentaire !== '' && commentaires[commentaire.id].texte === ''}">
          </b-form-textarea>
        </b-col>
        <b-col md="2" class="align-middle">
          <b-form-checkbox v-model="commentaires[commentaire.id].is_urgent" name="check-button"
                           switch> Urgent
          </b-form-checkbox>
          <b-form-checkbox v-model="commentaires[commentaire.id].is_relation_client" name="check-button"
                           switch> Relation Client
          </b-form-checkbox>
          <i class="fa fa-trash fa-1_5x mt-1 text-danger clickable" v-if="canDeleteCommentaire(commentaire)" v-b-tooltip.hover title="Supprimer le commentaire"
          @click="deleteCommentaire(commentaire)"></i>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <button v-if="addComHidden" type="button" title="Ajouter un commentaire"
                  class="btn btn-succes mr-1  pull-right" @click="addComHidden = false"><i
            class="fa fa-plus-circle fa-2x text-success" aria-hidden="true"></i></button>
        </b-col>
      </b-row>
      <b-row v-if="!addComHidden">
        <b-col md="10">
          <b-card no-body class="mt-3">
            <div class="card-smallHeader">
              <i class="fa fa-justify mr-2"></i>
              <strong>Ajouter un commentaire</strong>
            </div>
            <b-card-body>
              <b-form-group>
                <b-form-textarea
                  v-model="commentaireToAdd"
                  placeholder="Saisir un commentaire..."
                  rows="3"
                  max-rows="6"
                  :class="{hasError: errors.commentaire !== '' && commentaireToAdd === '' && (isUrgentToAdd === true || isRelationClientToAdd === true)}"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group class="align-middle">
                <b-form-checkbox v-model="isUrgentToAdd" name="check-button" switch> Urgent</b-form-checkbox>
              </b-form-group>
              <b-form-group class="align-middle">
                <b-form-checkbox v-model="isRelationClientToAdd" name="check-button" switch> Relation Client</b-form-checkbox>
              </b-form-group>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <span class="field-error inline mr-1 float-right">{{ errors.commentaire }}</span>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModal()">Annuler</button>
          <button type="button" @click="saveCommentaire()" class="btn btn-primary"><i class="fa fa-save"></i>
            Enregistrer
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { isEmpty } from '@/utils/fileHelper';
  import moment from 'moment';
  import {isResponsable} from "@/utils/userHelper";
  import {getUser} from "@/utils/auth";
  import Multiselect from 'vue-multiselect';
  import {getIconPostit} from "@/utils/communHelper";

  export default {
    name: "DonneesSinistre",
    components: {
      Multiselect,
    },
    props: [
      'dossier'
    ],
    data() {
      return {
        allCanals: [],
        // allTypesAR: [],
        allTypesAROptions: [
          {value: 'ar_mail', text: 'AR mail'},
          {value: 'ar_courrier', text: 'AR courrier'},
          {value: 'ar_sans', text: 'Sans AR'},
          {value: 'ar_non_renseigne', text: 'Non renseigné'},
          // {value: null, text: 'Sélectionner un type d\'AR'},
        ],
        allMotifsRejet: [],
        allMotifsRejetOption: [],
        motifsRejet: [],
        commentaires: [],
        commentairesOriginaux: [],
        commentairesGestion: [],
        dossierIdForCommentaire: '',
        commentaireToAdd: '',
        showMotifsRejet: false,
        isNotTraitementQC: false,
        isUrgentToAdd: false,
        isRelationClientToAdd: false,
        addComHidden: true,
        myData: {
          dateReception: '',
          dateReceptionCourrier: '',
          dateSignature: '',
          timeSignature: '00:00',
          reponseDb: '',
          typeSupport: '',
          selectedCanal: null,
          dbcoType: '',
          garantiePret: false,
          isConforme: null,
          rar: '',
          numero_archive: '',
          dbcoUuid: '',
          yousignId: '',
          selectedMotifsRejet: [],
          selectedAccuseReception: null,
        },
        errors: {
          commentaire: '',
          dateSignature: '',
          dateReceptionCourrier: '',
          selectedAccuseReception: '',
          selectedMotifsRejet: '',
          reponseDb: '',
          dbcoType: '',
          isConforme: '',
          dbcoUuid: '',
          yousignId: '',
        }
      }
    },
    watch: {
      myData: {
        handler: _.debounce(function (value) {
          this.$event.emit('editDossier', 'DonneesDbco', value);
        }, 2000),
        deep: true,
      },
      'myData.isConforme'(newVal, oldVal){
        this.showMotifsRejet = this.myData.isConforme !== null && this.myData.isConforme === 'false';
        if (this.myData.isConforme === null || this.myData.isConforme === 'true') {
          this.motifsRejet = [];
        }
        if (!isEmpty(oldVal)) {
          this.$event.emit('changeConformiteDBCO', newVal);
        } else {
          this.$event.emit('initConformiteDBCO', newVal);
        }
      },
      'myData.dbcoType'(newVal, oldVal){
        // On commence par enlever les motifs de l'autre type qui auraient été sélectionné si dans le cas d'un changement de type
        if (!isEmpty(oldVal)) {
          this.myData.selectedMotifsRejet = [];
          this.motifsRejet = [];
        }
        
        // On réinitialise le select des motifs
        this.generateMotifRejetListe();
      },
      'myData.garantiePret'(newVal){
        if (this.myData.garantiePret === 'true' || this.myData.garantiePret === true) {
          this.myData.reponseDb = 'expresse';
        } else {
          this.myData.reponseDb = '';
        }
      },
      motifsRejet() {
        if (this.motifsRejet) {
          this.myData.selectedMotifsRejet = this.motifsRejet.map( item => item.code);
        } else {
          this.myData.selectedMotifsRejet = [];
        }
      },
      allMotifsRejet() {
        this.populateMotif();
      }
    },
    created() {
      this.$event.on('saveError', (errors) => {
        this.errors = errors;
      })
    },
    mounted() {
      this.setForm();
      this.getCanals();
      this.getMotifRejet();
      this.setCommentaires();

      this.isNotTraitementQC = !this.$parent.$parent.$parent.isQualification;
    },
    methods: {
      setForm() {
        // console.log('this.dossier',this.dossier)
        this.myData.dateReception = this.formatDate(this.dossier.date_reception);
        this.myData.dateReceptionCourrier = !isEmpty(this.dossier.date_reception_courrier) ? this.formatDate(this.dossier.date_reception_courrier) : this.formatDate(this.dossier.date_reception);
        this.myData.dateSignature = this.formatDate(this.dossier.date_signature);
        this.myData.timeSignature = this.getTime(this.dossier.date_signature);
        this.myData.selectedAccuseReception = !isEmpty(this.dossier.accuse_reception) ? this.dossier.accuse_reception : null;
        this.myData.reponseDb = this.dossier.dbco_reponse;
        this.myData.dbcoType = this.dossier.dbco_type;
        this.myData.garantiePret = this.dossier.garantie_pret;
        this.myData.typeSupport = this.dossier.type_support;
        this.myData.selectedCanal = this.dossier.canal_id;
        this.myData.rar = this.dossier.rar;
        this.myData.numArchives = this.dossier.numero_archive;
        this.myData.isConforme = this.dossier.is_conforme ? 'true' : (this.dossier.is_conforme === false ? 'false' : null);
        for (let motif of this.dossier.motifs_rejet) {
          this.myData.selectedMotifsRejet.push(motif.id);
        }
        this.populateMotif();
        this.myData.dbcoUuid = this.dossier.dbco_uuid;
        this.myData.yousignId = this.dossier.yousign_id;
      },
      getCanals() {
        let self = this;
        this.$axios
          .get("/espaceGestion/dossier/getAllCanal")
          .then(response => {
            for (let canal of response.data.data) {
              this.allCanals.push({value: canal.id, text: canal.libelle});
            }
          })
          .catch(function (error) {
            console.log(error);
            let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';

            // self.$store.commit('IS_LOADING', false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: textError,
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      getMotifRejet() {
        let self = this;
        this.$axios
          .get("/espaceGestion/dossier/getAllMotifsRejet/dbco")
          .then(response => {
            // console.log(response);
            this.allMotifsRejet = response.data.motifsRejet;
            this.$parent.$parent.$parent.allMotifsRejet = response.data.motifsRejet;
            this.generateMotifRejetListe();
          })
          .catch(function (error) {
            console.log(error);
            let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';

            // self.$store.commit('IS_LOADING', false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: textError,
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      generateMotifRejetListe() {
        let dbcoType = !isEmpty(this.myData.dbcoType) ? this.myData.dbcoType.toLowerCase() : (!isEmpty(this.dossier.dbcoType) ? this.dossier.dbcoType.toLowerCase() : null);
        // Initialisation du select
        this.allMotifsRejetOption = [];
        // Génération du select
        for (let motif of this.allMotifsRejet) {
          if (motif.type_dossier.toLowerCase() === dbcoType) {
            this.allMotifsRejetOption.push({code: motif.id, name: motif.libelle_court});
          }
        }
      },
      isDisabled(field) {
        return this.$parent.$parent.$parent.isDisabled(field)
      },
      formatDate(textDate) {
        let formattedDate = null;
        if (!isEmpty(textDate) && textDate !== 'Invalid date') {
          let date = new Date(textDate).toLocaleDateString("fr-FR").split('/');
          // console.log(textDate,date)
          formattedDate = `${date[2]}-${date[1]}-${date[0]}`;
        }
        return formattedDate;
      },
      getTime(textDate) {
        let time = !isEmpty(textDate) ? textDate.split(' ')[1] : '00:00';
        return time;
      },
      populateMotif() {
        this.motifsRejet = [];
        for (let id of this.myData.selectedMotifsRejet) {
          let name = "";
          for (let element of this.allMotifsRejetOption) {
            if (element.code === parseInt(id,10)) {
              name = element.name
            }
          }
          this.motifsRejet.push({code: id, name: name});
        }
      },
      editCommentaire(dossier) {
        this.commentairesGestion = dossier.commentaires_gestion;
        this.dossierIdForCommentaire = dossier.id;
        this.$refs['modal-commentaire'].show();
      },
      saveCommentaire() {
        if (this.validateCommentaires()) {
          let self = this;
          let dataPost = {
            'dossierId': this.dossierIdForCommentaire,
            'commentaireExistant': this.commentaires,
            'newCommentaireTexte': this.commentaireToAdd,
            'newCommentaireIsUrgent': this.isUrgentToAdd,
            'newCommentaireIsRelationClient': this.isRelationClientToAdd,
          };
          this.$store.commit('IS_LOADING', true);
          this.$axios
            .post('/espaceGestion/dossier/commentaire', dataPost)
            .then(response => {
              this.$event.emit('refreshDossier');
              this.$store.commit('IS_LOADING', false);
              this.closeModal();
              this.dossier.commentaires_gestion = response.data.commentaires;
              this.setCommentaires();
              this.$swal({
                position: "top",
                type: "success",
                title: "Succès !",
                text: 'Commentaire bien enregistré',
                showConfirmButton: false,
                timer: 3000
              });
            })
            .catch(function (error) {
              console.log(error);
              let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
              if (error.response.status === 400) {
                textError = 'Vous devez saisir un commentaire';
              }
              self.$store.commit('IS_LOADING', false);
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: textError,
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      canDeleteCommentaire(commentaire) {
        // console.log('commentaire',commentaire)
        let user = getUser();
        return !isEmpty(commentaire.gestionnaire) && (isResponsable() || parseInt(commentaire.gestionnaire.id,10) === parseInt(user.id,10));
      },
      deleteCommentaire(commentaire) {
        let self = this;
        let data = {};
        let dossier_id = commentaire.dossier_id;

        data.traitementId = this.$route.query.traitementId;
        // console.log('this.$axios',this.$axios)
        this.$swal.fire({
          title: 'Êtes-vous sûr?',
          text: 'Voulez-vous vraiment supprimer ce commentaire ?',
          type: 'warning',
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor:'#ff1744',
          confirmButtonText: 'Annuler',
          cancelButtonText: 'Supprimer',
        }).then((result) => {
          if (result.value !== true) {
            data.commentaireId = commentaire.id;
            data.dossierId = dossier_id;
            this.$store.commit('IS_LOADING', true);
            this.$axios
              .post('/espaceGestion/dossier/commentaire/delete',data)
              .then(response => {
                this.$store.commit('IS_LOADING', false);
                // this.$event.emit('refreshDossier');
                this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'Le commentaire a bien été supprimé',showConfirmButton: false, timer: 3000});
                this.dossier.commentaires_gestion = response.data.commentaires;
                this.setCommentaires();
                // on met à jour les commentaires affichés dans le modal
                this.commentairesGestion = response.data.commentaires;
              })
              .catch(function(error){
                console.log(error)
                self.$store.commit('IS_LOADING', false)
                self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue lors de la suppression du commentaire. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
              })
          }
        })
      },
      closeModal() {
        this.$refs['modal-commentaire'].hide();
        this.remiseAZero();
      },
      remiseAZero() {
        this.addComHidden = true;
        this.commentaireToAdd = '';
        this.isUrgentToAdd = false;
        this.isRelationClientToAdd = false;
        this.commentairesGestion = [];
        this.dossierIdForCommentaire = '';
        this.clearError();
      },
      validateCommentaires() {
        let error = false;
        for (let commentaireKey in this.commentaires[this.dossierIdForCommentaire]) {
          if (commentaireKey === undefined) {
            continue;
          }
          if (this.commentaires[this.dossierIdForCommentaire][commentaireKey].texte === '') {
            error = true;
            this.errors.commentaire = 'Vous ne pouvez pas enregistrer un commentaire vide';
          }
        }
        if (this.commentaireToAdd.trim() === '' && this.isUrgentToAdd === true) {
          error = true;
          this.errors.commentaire = 'Vous ne pouvez pas enregistrer un commentaire vide';
        }

        if (this.commentaireToAdd.trim() === '' && this.isRelationClientToAdd === true) {
          error = true
          this.errors.commentaire = 'Vous ne pouvez pas enregistrer un commentaire vide'
        }
        return !error;
      },
      getTypeDossier() {
        return this.dossier.type ? this.dossier.type.groupe.toLowerCase() : '';
      },
      getTypeInval() {
        let typeIncapcite = ['incao','incact'];
        return typeIncapcite.indexOf(this.dossier.type.libelle_technique) > -1 ? 'incap' : 'inval';
      },
      getTooltip() {
        let tooltip = '';
        for (let commentaire of this.commentairesOriginaux) {
          if(!isEmpty(commentaire)) {
            tooltip = tooltip + commentaire.texte + '\n';
          }
        }
        // console.log(tooltip)
        return tooltip;
      },
      getIconSrc(type, dossier) {
        return getIconPostit(type, dossier);
      },
      formatDateHeure(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleString("fr-FR") : "-";
      },
      clearError() {
        this.errors.commentaire = '';
        this.errors.dbcoType = '';
        this.errors.reponseDb = '';
        this.errors.dateSignature = '';
        this.errors.dateReceptionCourrier = '';
        this.errors.selectedMotifsRejet = '';
        this.errors.selectedAccuseReception = '';
        this.errors.isConforme = '';
      },
      onPaste(evt, type) {
        evt.stopPropagation();
        evt.preventDefault();
        let clipboardData = evt.clipboardData || window.clipboardData;
        let pastedData = clipboardData.getData('Text');
        pastedData = moment(pastedData, 'DD/MM/YYYY').format('YYYY-MM-DD');

        if(type === 'debut') {
          this.myData.dateDebutSinistre = this.formatDate(pastedData);
        } else if(type === 'fin') {
          this.myData.dateFinSinistre = this.formatDate(pastedData);
        }
      },
      setCommentaires() {
        // console.log('dossier',this.dossier)
        this.commentaires = {};
        this.commentairesOriginaux = [];
        for (let commentaire of this.dossier.commentaires_gestion) {
          if(!isEmpty(commentaire)) {
            this.commentaires[commentaire.id] = {
              texte: commentaire.texte,
              is_urgent: commentaire.is_urgent,
              is_relation_client: commentaire.is_relation_client
            }
            this.commentairesOriginaux[commentaire.id] = {
              texte: commentaire.texte,
              is_urgent: commentaire.is_urgent,
              is_relation_client: commentaire.is_relation_client
            }
          }
        }
      },
      isTypeDossierByLibelleTechnique(libelle_technique) {
        // Gestion Invalidité : Ouverture ==> 'ino'
        // Gestion Invalidité : Changement de catégorie ==> 'invcc'
        // Gestion Incapacité : Ouverture ==> 'incao'
        // Gestion Incapacité : Changement de taux ==> 'incact'
        return this.dossier.type ? this.dossier.type.libelle_technique === libelle_technique : false;
      },
      disableTypeRente() {
        // let inputConjoint = document.getElementById('conjoint');
        let inputEduc = document.getElementById('education');
        let inputOcirp = document.getElementById('ocirp');
        // inputConjoint.disabled = this.myData.typeRente.indexOf('ocirp') > -1;
        inputEduc.disabled = this.myData.typeRente.indexOf('ocirp') > -1;
        inputOcirp.disabled = this.myData.typeRente.indexOf('education') > -1;
      },
      disableCapitalDeces() {
        let inputCapital = document.getElementById('capital');
        let inputCapitalPlus = document.getElementById('capital_plus');
        inputCapital.disabled = this.myData.capitalDeces.indexOf('capital_plus') > -1;
        inputCapitalPlus.disabled = this.myData.capitalDeces.indexOf('capital') > -1;
      },
    }
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .disabled-input {
    background-color: #c3e6f1 !important;
  }

</style>
<style type="text/css">
  .tooltip.b-tooltip.pre-formatted .tooltip-inner {
    white-space: pre-line;
    max-width: 100% !important;
  }

  .tooltip.b-tooltip.pre-formatted {
    max-width: 100%;
  }
</style>
